import { Subscription } from 'rxjs';
import { Module } from './../services/menu/responses/menu.response';
import { ActualSubmenu, ActualMenu } from './../menu-nav-bar/interfaces/actual-submenu.interface';
import { ActivatedRoute, Router, Event, NavigationEnd } from '@angular/router';
import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges, OnDestroy {

  @Input() modules: Module[] = [];
  actualSubmenu: ActualSubmenu = null;

  listenRoutesSubscription$: Subscription;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
  ) {
    this.listenRoutes();
  }

  ngOnInit(): void {
    this.updateActualSubmenu(this.router.url);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modules'] && changes['modules'].previousValue && changes['modules'].currentValue && changes['modules'].previousValue.length !== changes['modules'].currentValue.length) {
      this.updateActualSubmenu(this.router.url);
    }
  }

  listenRoutes() {
    this.listenRoutesSubscription$ = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.updateActualSubmenu(event.urlAfterRedirects);
      }
    });
  }

  updateActualSubmenu(url: string) {
    if (url.endsWith('/')) {
      url = url.substr(0, url.length - 1);
    }
    const candidatos: ActualSubmenu[] = [];
    for (let i = 0; i < this.modules.length; i++) {
      const modu = this.modules[i];
      for (let j = 0; j < modu.menu.length; j++) {
        const menu = modu.menu[j];
        for (let k = 0; k < menu.sub_menu.length; k++) {
          const submenu = menu.sub_menu[k];
          if (url.includes(submenu.url || '-nope-')) {
            let actualMenu: ActualMenu = { ...menu, module: modu };
            const actualSubmenu = { ...submenu, menu: actualMenu };
            candidatos.push(actualSubmenu)
          }
        }
      }
    }
    if (candidatos.length > 0) {
      for(let i = 0; i < candidatos.length; i++) {
        if (url === candidatos[i].url) {
          this.actualSubmenu = candidatos[i];
          return;
        }
      }
      this.actualSubmenu = candidatos[candidatos.length - 1];
      return;
    }
    this.actualSubmenu = null;
  }

  ngOnDestroy(): void {
    if (this.listenRoutesSubscription$) {
      this.listenRoutesSubscription$.unsubscribe();
    }
  }

}
